
import { IconPackage } from '@ds/icons/IconPackage'

import { PaymentAdvertisement } from '@payment'
import { trackClick } from '@tracking/events'

import translations from './AdvertisedPayment.translations'

export default {
  components: {
    IconPackage,
    PaymentAdvertisement,
  },

  props: {
    paymentMethods: {
      type: Array,
      default: () => [],
    },

    price: {
      type: Object,
      required: true,
    },
  },

  computed: {
    translations: () => translations,
  },

  methods: {
    trackOpen(advertisement) {
      trackClick({
        zone: 'installment plans',
        name: advertisement.method.networks.join(','),
      })
    },
  },
}
